import React from 'react';
import { ProcessContainer } from './styled';
import { Stepper4040, useResponsive } from '@aptuno/aptuno-ui';
import { usePublicationRouter } from '@contexts/PropertyListingPublications/components/shared';

const ProcessInfoBar = () => {
  const router = usePublicationRouter();
  const responsive = useResponsive();

  const mappedSteps = React.useMemo(() => {
    return Object.entries(router.steps).map(([key, value]) => {
      return {
        title: value.title,
        description: responsive.isMobile
          ? value.description.mobile
          : value.description.desktop,
      };
    });
  }, [router.steps]);

  return (
    <ProcessContainer>
      <Stepper4040 steps={mappedSteps} activeStep={router.currentStep.index} />
    </ProcessContainer>
  );
};

export { ProcessInfoBar, ProcessInfoBar as default };
